












import Vue from "vue";
import Logo from "../assets/background/bg-replay.svg";
export default Vue.extend({
  components: {
    Logo,
  },
});
